module.exports = __webpack_public_path__ + "static/media/Twodash_purple.fca19afe.svg";